<template>
  <div
    v-clickoutside="closeDropdown"
    class="language-select search-filters-select"
  >
    <div class="search-filters-select__title">
      <button
        :aria-expanded="isDropdownOpen ? 'true' : 'false'"
        :class="[
          'search-filters-select__title-filter',
          { 'search-filters-select__title-filter--active': isDropdownOpen }
        ]"
        @click="toggleDropdown"
      >
        {{ selected.label }}
        <svg
          :class="['icon', { 'icon--opened': isDropdownOpen }]"
          role="img"
        >
          <title
            v-if="iconLabels"
            class="is-sr-only"
            v-text="iconLabel"
          />
          <use xlink:href="#chevron-right" />
        </svg>
      </button>
    </div>

    <div
      v-show="isDropdownOpen"
      :aria-hidden="isDropdownOpen ? 'false' : 'true'"
      class="search-filters-select__popup search-filters-select__popup--sorting"
    >
      <label
        v-for="option in languages.options"
        :key="option.labelShort"
        class="search-filters-select__option search-filters-select__option--sorting"
      >
        <input
          :checked="checkIsActive(option)"
          :name="`search-filter-option-${_uid}`"
          type="radio"
          @change="selectLanguage(option)"
        >
        <span class="checkmark" />
        {{ option.label }}
      </label>
    </div>
  </div>
</template>

<script>
  import { clickoutside } from '@Foundation/directives/clickoutside/clickoutside';

  export default {
    name: 'LanguageSelect',

    directives: {
      clickoutside
    },

    props: {
      iconLabels: { default: null, type: Object },
      languages: { type: Object, required: true },
    },

    data() {
      return {
        isDropdownOpen: false,
        selected: null,
      };
    },

    computed: {
      iconLabel() {
        if (!this.iconLabels) {
          return;
        }

        return this.isDropdownOpen ? this.iconLabels.close : this.iconLabels.open;
      }
    },

    created() {
      this.selected = this.languages.options.find(e => e.labelShort === this.languages.selected);
    },

    methods: {
      checkIsActive(option) {
        return this.selected.labelShort === option.labelShort;
      },

      closeDropdown() {
        this.isDropdownOpen = false;
      },

      selectLanguage(option) {
        window.location.href = option.link;
      },

      toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
      },
    },
  };
</script>

<style lang="scss" scoped>
.language-select {
  margin-inline: rem(7px);
  padding: 0;
  position: relative;

  @include for('large') {
    margin: 0;
  }

  .search-filters {
    $font-size: rem(16px);

    &-select {
      &__option {
        font-size: $font-size;
        line-height: 1;
        padding-left: rem(26px);
        text-transform: none;

        .checkmark {
          height: rem(16px);
          width: rem(16px);

          &::after {
            height: rem(11.25px);
            top: 1px;
            width: rem(6px);
          }
        }
      }

      &__popup {
        row-gap: rem(16px);

        &--sorting {
          padding: rem(21px) rem(21px) rem(21px) rem(10px);
        }
      }

      &__title {
        font-size: $font-size;
        line-height: 1;

        .icon {
          height: 0.75rem;
          width: 0.75rem;
        }

        &-filter {
          color: var(--mcb-language-selector-search-filter-select-title-filter-text-color);
          font-family: inherit;
          font-size: $font-size;
          line-height: 1.25;
          margin: 0;
          text-transform: none;
        }
      }
    }
  }
}
</style>
